var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ai-chat-layout bg-white rounded-lg shadow-sm border border-neutral-200"
  }, [_vm.showMobileSidebar ? _c('div', {
    staticClass: "mobile-backdrop absolute inset-0 bg-black bg-opacity-50 z-40",
    on: {
      "click": function click($event) {
        _vm.showMobileSidebar = false;
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "ai-sidebar bg-white border-r border-neutral-200",
    class: {
      'mobile-open': _vm.showMobileSidebar
    }
  }, [_c('div', {
    staticClass: "ai-sidebar-header p-4 border-b border-neutral-200 flex justify-between items-center"
  }, [_c('button', {
    staticClass: "w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors duration-200",
    on: {
      "click": _vm.startNewChat
    }
  }, [_c('svg', {
    staticClass: "h-5 w-5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v(" New Chat ")]), _vm.showMobileSidebar ? _c('button', {
    staticClass: "ml-2 p-2 text-neutral-500 bg-neutral-100 rounded-lg mobile-close-btn",
    on: {
      "click": function click($event) {
        _vm.showMobileSidebar = false;
      }
    }
  }, [_c('svg', {
    staticClass: "h-5 w-5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M6 18L18 6M6 6l12 12"
    }
  })])]) : _vm._e()]), _c('div', {
    staticClass: "ai-sidebar-list p-3 custom-scrollbar"
  }, [_c('p', {
    staticClass: "text-xs font-semibold text-neutral-400 uppercase tracking-wider px-2 mb-2"
  }, [_vm._v("Riwayat")]), _vm.isSidebarLoading ? _c('div', {
    staticClass: "p-4 text-center text-sm text-neutral-400"
  }, [_vm._v(" Loading history... ")]) : _c('div', _vm._l(_vm.sessions, function (history, index) {
    return _c('div', {
      key: history.id || index,
      staticClass: "group p-3 mb-2 rounded-xl cursor-pointer transition-all duration-200 border",
      class: _vm.activeChatId === history.id ? 'bg-blue-50 border-blue-200 shadow-sm' : 'bg-white border-transparent hover:bg-neutral-100',
      on: {
        "click": function click($event) {
          return _vm.selectHistory(history.id);
        }
      }
    }, [_c('h4', {
      staticClass: "text-sm font-semibold text-neutral-800 mb-1 truncate"
    }, [_vm._v(" " + _vm._s(history.title) + " ")]), _c('p', {
      staticClass: "text-xs text-neutral-500 truncate mb-1.5 opacity-90"
    }, [_vm._v(" " + _vm._s(history.lastMessage || 'Klik untuk melihat pesan...') + " ")]), _c('div', {
      staticClass: "flex justify-end border-t border-dashed border-neutral-200 pt-1.5 mt-1"
    }, [_c('span', {
      staticClass: "text-xs font-medium text-neutral-400 group-hover:text-neutral-500 transition-colors"
    }, [_vm._v(" " + _vm._s(history.date) + " ")])])]);
  }), 0)])]), _c('div', {
    staticClass: "ai-chat-room bg-white relative"
  }, [_c('div', {
    staticClass: "mobile-header justify-between items-center p-3 border-b border-neutral-200 bg-white"
  }, [_c('div', {
    staticClass: "flex items-center gap-2"
  }, [_c('button', {
    staticClass: "p-2 bg-neutral-100 rounded-md text-neutral-600 hover:bg-neutral-200",
    on: {
      "click": function click($event) {
        _vm.showMobileSidebar = true;
      }
    }
  }, [_c('svg', {
    staticClass: "h-5 w-5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M4 6h16M4 12h16M4 18h16"
    }
  })])]), _c('h3', {
    staticClass: "font-semibold text-neutral-700"
  }, [_vm._v("AI Assistant")])])]), _c('div', {
    ref: "chatContainer",
    staticClass: "ai-chat-messages bg-neutral-50 p-6 custom-scrollbar"
  }, [_vm.currentMessages.length === 0 && !_vm.isLoading ? _c('div', {
    staticClass: "h-full flex flex-col items-center justify-center text-center opacity-60"
  }, [_c('div', {
    staticClass: "w-16 h-16 bg-neutral-200 rounded-full flex items-center justify-center mb-4"
  }, [_c('svg', {
    staticClass: "h-8 w-8 text-neutral-500",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
    }
  })])]), _c('h3', {
    staticClass: "text-lg font-medium text-neutral-700"
  }, [_vm._v("Mulai percakapan baru")]), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Tanyakan tentang pengiriman, alamat, atau minta buatkan pengiriman.")])]) : _vm._e(), _vm._l(_vm.currentMessages, function (msg, index) {
    return _c('div', {
      key: index,
      staticClass: "flex w-full mb-6 last:mb-0",
      class: msg.role === 'user' ? 'justify-end' : 'justify-start'
    }, [msg.role === 'agent' ? _c('div', {
      staticClass: "w-8 h-8 rounded-full bg-blue-100 flex-shrink-0 flex items-center justify-center mr-2 mt-1 text-blue-600 text-xs font-bold"
    }, [_vm._v("AI")]) : _vm._e(), _c('div', {
      staticClass: "max-w-[85%] sm:max-w-[75%]"
    }, [_c('div', {
      staticClass: "px-4 py-3 rounded-2xl text-sm leading-relaxed shadow-sm markdown-content",
      class: [msg.role === 'user' ? 'bg-blue-600 text-white rounded-br-none' : 'bg-white text-neutral-800 border border-neutral-200 rounded-bl-none'],
      domProps: {
        "innerHTML": _vm._s(_vm.renderMarkdown(msg.content))
      }
    })])]);
  }), _vm.isLoading ? _c('div', {
    staticClass: "flex w-full mb-6 justify-start"
  }, [_c('div', {
    staticClass: "w-8 h-8 rounded-full bg-blue-100 flex-shrink-0 flex items-center justify-center mr-2 mt-1 text-blue-600 text-xs font-bold"
  }, [_vm._v("AI")]), _vm._m(0)]) : _vm._e()], 2), _c('div', {
    staticClass: "ai-chat-input p-4 bg-white border-t border-neutral-200"
  }, [_c('div', {
    staticClass: "relative flex items-end gap-2 bg-neutral-100 p-2 rounded-xl border border-neutral-200 focus-within:ring-2 focus-within:ring-blue-100 focus-within:border-blue-300 transition-all"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputMessage,
      expression: "inputMessage"
    }],
    ref: "msgInput",
    staticClass: "w-full bg-transparent border-none focus:ring-0 text-sm text-neutral-800 placeholder-neutral-400 resize-none py-2 px-2 max-h-32 focus:outline-none disabled:opacity-50",
    staticStyle: {
      "min-height": "44px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "placeholder": "Ketik pesan anda di sini...",
      "rows": "1"
    },
    domProps: {
      "value": _vm.inputMessage
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.inputMessage = $event.target.value;
      }
    }
  }), _c('button', {
    staticClass: "p-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:bg-neutral-300 disabled:cursor-not-allowed transition-colors mb-1",
    attrs: {
      "disabled": !_vm.inputMessage.trim() || _vm.isLoading
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_c('svg', {
    staticClass: "h-5 w-5 transform rotate-90",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"
    }
  })])])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white border border-neutral-200 px-4 py-3 rounded-2xl rounded-bl-none shadow-sm flex items-center gap-1"
  }, [_c('span', {
    staticClass: "w-1.5 h-1.5 bg-neutral-400 rounded-full animate-bounce"
  }), _c('span', {
    staticClass: "w-1.5 h-1.5 bg-neutral-400 rounded-full animate-bounce",
    staticStyle: {
      "animation-delay": "0.1s"
    }
  }), _c('span', {
    staticClass: "w-1.5 h-1.5 bg-neutral-400 rounded-full animate-bounce",
    staticStyle: {
      "animation-delay": "0.2s"
    }
  })]);
}]

export { render, staticRenderFns }